module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('v-card-title', [_c('h3', [_vm._v("Inventory report")])]), _vm._v(" "), _c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": "",
      "md5": "",
      "px-1": "",
      "mt-2": ""
    }
  }, [_c('v-flex', {
    staticClass: "date__picker"
  }, [_c('v-menu', {
    attrs: {
      "close-on-content-click": false,
      "nudge-right": 40,
      "lazy": "",
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "min-width": "290px"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-text-field', _vm._g({
          attrs: {
            "label": "Period starts from:",
            "prepend-icon": "event",
            "readonly": ""
          },
          model: {
            value: (_vm.from),
            callback: function($$v) {
              _vm.from = $$v
            },
            expression: "from"
          }
        }, on))]
      }
    }]),
    model: {
      value: (_vm.menu),
      callback: function($$v) {
        _vm.menu = $$v
      },
      expression: "menu"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    on: {
      "input": function($event) {
        _vm.menu = false
      }
    },
    model: {
      value: (_vm.from),
      callback: function($$v) {
        _vm.from = $$v
      },
      expression: "from"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": "",
      "md5": "",
      "px-1": "",
      "mt-2": ""
    }
  }, [_c('v-flex', {
    staticClass: "date__picker"
  }, [_c('v-menu', {
    attrs: {
      "close-on-content-click": false,
      "nudge-right": 40,
      "lazy": "",
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "min-width": "290px"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-text-field', _vm._g({
          attrs: {
            "label": "Period end on:",
            "prepend-icon": "event",
            "readonly": ""
          },
          model: {
            value: (_vm.to),
            callback: function($$v) {
              _vm.to = $$v
            },
            expression: "to"
          }
        }, on))]
      }
    }]),
    model: {
      value: (_vm.menu1),
      callback: function($$v) {
        _vm.menu1 = $$v
      },
      expression: "menu1"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    on: {
      "input": function($event) {
        _vm.menu1 = false
      }
    },
    model: {
      value: (_vm.to),
      callback: function($$v) {
        _vm.to = $$v
      },
      expression: "to"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": "",
      "md2": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "large": ""
    },
    on: {
      "click": _vm.search
    }
  }, [_c('v-icon', [_vm._v("search")])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "mt-5": ""
    }
  }, _vm._l((_vm.errors), function(error, i) {
    return _c('v-flex', {
      key: i
    }, [(error.status) ? _c('v-alert', {
      attrs: {
        "type": "error",
        "value": true
      }
    }, [_vm._v("\n              " + _vm._s(error.text) + "\n            ")]) : _vm._e()], 1)
  }), 1)], 1)], 1), _vm._v(" "), _c('v-layout', [_c('v-flex', [_c('h3', [_vm._v("Report:")]), _vm._v(" "), (_vm.report.length) ? _c('v-flex', {
    attrs: {
      "right": ""
    }
  }, [_c('v-btn', [_c('json-c-s-v', {
    attrs: {
      "name": _vm.dataFile,
      "labels": _vm.labelsCSV,
      "fields": _vm.fieldsCSV,
      "data": _vm.report
    }
  }, [_vm._v("\n              Export CSV\n              "), _c('v-icon')], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md12": ""
    }
  }, [_c('v-data-table', {
    attrs: {
      "items": _vm.report,
      "headers": _vm.reportHeaders,
      "loading": _vm.loading,
      "hide-actions": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', [_vm._v(_vm._s(props.item.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.all_quantity))])]
      }
    }])
  })], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0a41cecb","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/InventoryReport.vue
// module id = 928
// module chunks = 1